import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Wrapper from '../common/Wrapper';
import Header from '../common/Header';
import NotificationBar from '../Parts/NotificationBar.jsx'
import NotificationBanner from '../common/NotificationBanner';
import LetterAutoGeneratePanel from './panels/LetterAutoGeneratePanel';
import PlanDialog from '../SendLetter/dialogs/PlanDialog';
import PromotePlanChangeDialog from '../common/PromotePlanChangeDialog';
import { PromotePlanDialogTypes } from '../../constants/ComponentTypes';

const styles = () => ({
  root: {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
  },

  main: {
    background: "#FAFAFA",
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },

  content: {
    transform: 'translateY(20px)',
    width: '800px',
    padding: '60px 0 196px',
    boxSizing: 'border-box',
    display: 'flex',
  },
});

class LetterAutoGenerate extends React.Component {
  initialState = {
    showPlanDialog: false,
    [PromotePlanDialogTypes.LETTER_AUTO_GENERATE.flag]: false,
    showNotification: false,
  }

  constructor(props) {
    super(props);
    this.state = { ...this.initialState };
  }

  componentDidMount() {
    this.props.getUserInfo();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.successMessage !== this.props.successMessage && this.props.successMessage && this.props.successMessage !== '') {
      this.displayNotification(this.props.successMessage, "success");
    } else if (prevProps.errorMessage !== this.props.errorMessage && this.props.errorMessage && this.props.errorMessage !== '') {
      this.displayNotification(this.props.errorMessage, "error");
    } else if (prevProps.shortMessage !== this.props.shortMessage && this.props.shortMessage && this.props.shortMessage !== '') {
      this.displayNotification(this.props.shortMessage, "green");
    }
  }

  togglePlanDialog = () => {
    this.setState({
      showPlanDialog: !this.state.showPlanDialog,
    });
  }

  togglePromotePlanChangeDialog = (type) => {
    this.setState({
      [type["flag"]]: !(this.state[type["flag"]])
    });
  }

  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    })
  };

  renderPlanDialog = () => (
    <PlanDialog
      isOpen={this.state.showPlanDialog}
      toggleDialog={this.togglePlanDialog}
    />
  );

  renderPromotePlanChangeDialog = (type) => {
    return (
      <PromotePlanChangeDialog
        isOpen={this.state[type["flag"]]}
        type={type}
        toggleDialog={() => this.togglePromotePlanChangeDialog(type)}
        handlePlanChange={this.togglePlanDialog}
      />
    );
  };

  renderNotification = () => {
    return (
      <div style={{ position: 'fixed', zIndex: 10000, top: 10, width: '98%', left: '1%' }}>
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={() => {
            this.setState({ showNotification: false })
          }}
          autoClose={false}
          style={{
            width: this.state.messageType === "green" ? "fit-content" : '100%',
          }}
        >
        </NotificationBar>
      </div>
    );
  };

  render() {
    const { classes } = this.props;

    let planDialog, notification, promoteLetterCorrectionDialog;
    if (this.state.showPlanDialog) { planDialog = this.renderPlanDialog(); }
    if (this.state.showNotification) { notification = this.renderNotification(); }
    if (this.state[PromotePlanDialogTypes.LETTER_AUTO_GENERATE.flag]) { promoteLetterCorrectionDialog = this.renderPromotePlanChangeDialog(PromotePlanDialogTypes.LETTER_AUTO_GENERATE); }

    return (
      <Wrapper className={classes.root}>
        <NotificationBanner user={this.props.user} />
        <Header title="レター文面作成" type="dark" hasBackBtn={false} />
        <div className={classes.main}>
          <div className={classes.content}>
            <LetterAutoGeneratePanel
              user={this.props.user}
              togglePlanDialog={this.togglePlanDialog}
              togglePromotePlanChangeDialog={() => this.togglePromotePlanChangeDialog(PromotePlanDialogTypes.LETTER_AUTO_GENERATE)}
              postGenerate={this.props.postGenerate}
              isGenerating={this.props.isGenerating}
              generatedContents={this.props.generatedContents}
            />
          </div>
        </div>
        {planDialog}
        {notification}
        {promoteLetterCorrectionDialog}
      </Wrapper>
    )
  }
}

LetterAutoGenerate.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  getUserInfo: PropTypes.func.isRequired,
  postGenerate: PropTypes.func.isRequired,
  isGenerating: PropTypes.bool.isRequired,
  generatedContents: PropTypes.string,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
};

export default withStyles(styles)(LetterAutoGenerate);



// WEBPACK FOOTER //
// ./src/components/LetterAutoGenerate/LetterAutoGenerate.jsx